import Routes from "routing/Routes";
export const PAGE_NAV_TITLE = "Users";
export const USERS_OVERVIEW_TITLE = "Users Overview";
const bindings = {
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        { description: USERS_OVERVIEW_TITLE, titleKey: "navigation:page_navigation.users_overview", path: Routes.SYSTEM.USERS.OVERVIEW },
        {
          description: "Token Management",
          titleKey: "navigation:page_navigation.token_management",
          path: Routes.SYSTEM.USERS_TOKEN_MANAGEMENT.overview,
          permissions: "users:tokenlist"
        }
      ]
    }
  ]
};
export default bindings;
